// src/redux/store.js
import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers/rootReducer';

// Load auth state from localStorage for persistence
const persistedState = {
  auth: JSON.parse(localStorage.getItem('auth')) || {}
};

const store = createStore(
  rootReducer,
  persistedState,
  applyMiddleware(thunk),
  // composeWithDevTools(applyMiddleware(thunk)), // Add redux devtools #### DISABLE FOR PRODUCTION!!!
);

// Persist auth state changes to localStorage
store.subscribe(() => {
  const { auth } = store.getState();
  localStorage.setItem('auth', JSON.stringify(auth));
});

export default store;
